import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api, download, errMsg } from "@/lib/api";
import { PageHeader, Kpi, Panel } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { EmailPromo } from "@/components/EmailPromo";

const Lista = ({ title, rows, testid }) => (
  <Panel title={title}>
    <ul className="space-y-2 text-sm" data-testid={testid}>
      {rows.length === 0 ? <li className="text-slate-500">Nessun dato</li> : rows.map((r) => (
        <li key={r.k} className="flex justify-between gap-3"><span className="truncate">{r.k}</span><span className="font-mono font-semibold">{r.n}</span></li>
      ))}
    </ul>
  </Panel>
);

const Grafico = ({ serie }) => {
  const max = Math.max(1, ...serie.map((s) => s.visite));
  return (
    <div className="flex h-40 items-end gap-1" data-testid="visits-chart">
      {serie.map((s) => (
        <div key={s.day} className="group relative flex-1" title={`${s.day.split("-").reverse().join("/")}: ${s.visite} visitatori, ${s.pagine} pagine`}>
          <div className="w-full rounded-t bg-sky-500 transition-colors group-hover:bg-sky-700" style={{ height: `${Math.max(2, (s.visite / max) * 150)}px` }} />
        </div>
      ))}
    </div>
  );
};

export default function Visite() {
  const [giorni, setGiorni] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/visite", { params: { giorni } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [giorni]);
  return (
    <div>
      <PageHeader title="Visite al sito" subtitle="Statistiche anonime delle pagine pubbliche, senza cookie">
        <div className="flex rounded-lg border border-sky-200 bg-sky-50 p-1">
          {[7, 30, 90].map((g) => <button key={g} type="button" data-testid={`visits-range-${g}`} onClick={() => setGiorni(g)} className={`rounded-md px-3 py-1.5 text-sm ${giorni === g ? "bg-sky-600 text-white" : "text-sky-900"}`}>{g} giorni</button>)}
        </div>
        <Button variant="outline" className="bg-white" data-testid="brochure-download-button" onClick={() => download("/admin/presentazione.pdf").catch((e) => toast.error(e.message))}><Download className="mr-2 h-4 w-4" />Presentazione PDF</Button>
      </PageHeader>
      <div className="mb-6"><EmailPromo /></div>
      {d && (
        <div className="space-y-6">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            <Kpi label="Visitatori" value={d.visitatori} testid="kpi-visitors" />
            <Kpi label="Pagine viste" value={d.pagine} testid="kpi-pageviews" />
            <Kpi label="Da telefono" value={`${d.mobile_pct}%`} testid="kpi-mobile" />
            <Kpi label="Prove gratuite" value={d.prove} testid="kpi-trials" />
            <Kpi label="Richieste account" value={d.richieste} testid="kpi-requests" />
          </div>
          <Panel title="Visitatori al giorno"><Grafico serie={d.serie} /></Panel>
          <div className="grid gap-6 lg:grid-cols-2">
            <Lista title="Pagine più viste" rows={d.top_pagine} testid="visits-top-pages" />
            <Lista title="Provenienza" rows={d.provenienza} testid="visits-referrers" />
          </div>
        </div>
      )}
    </div>
  );
}
